import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusBadge',
})
export class StatusBadgePipe implements PipeTransform {
  transform(value: string): string {
    let bgClass = '';
    switch (value.toLowerCase()) {
      case 'active':
        bgClass = 'bg-green';
        break;
      case 'paid':
        bgClass = 'bg-green';
        break;
      case 'completed':
        bgClass = 'bg-green';
        break;
      case 'approved':
        bgClass = 'bg-green';
        break;
      case 'approve':
        bgClass = 'bg-green';
        break;
      case 'partially_approved':
        bgClass = 'bg-amber';
        break;
      case 'requested_nullification':
        bgClass = 'bg-amber';
        break;
      case 'pending_payment':
        bgClass = 'bg-amber';
        break;
      case 'payment_pending':
        bgClass = 'bg-amber';
        break;
      case 'inactive':
        bgClass = 'bg-danger';
        break;
      case 'nulled':
        bgClass = 'bg-danger';
        break;
      case 'un_paid':
        bgClass = 'bg-danger';
        break;
      case 'reversed':
        bgClass = 'bg-danger';
        break;
      case 'reject':
        bgClass = 'bg-danger';
        break;
      case 'terminated':
        bgClass = 'bg-danger';
        break;
      case 'full':
        bgClass = 'bg-green';
        break;
      case 'open':
        bgClass = 'bg-green';
        break;
      case 'rejected':
        bgClass = 'bg-danger';
        break;
      case 'partial':
        bgClass = 'bg-amber';
        break;
      case 'suspended':
        bgClass = 'bg-amber';
        break;
      case 'pending':
        bgClass = 'bg-amber';
        break;
      case 'update':
        bgClass = 'bg-amber';
        break;
      case 'delete':
        bgClass = 'bg-danger';
        break;
      case 'failed':
        bgClass = 'bg-danger';
        break;
      case 'create':
        bgClass = 'bg-green';
        break;
      case 'true':
        bgClass = 'bg-green';
        break;
      case 'false':
        bgClass = 'bg-danger';
        break;
      case 'restore':
        bgClass = 'bg-green';
        break;
      default:
        bgClass = 'bg-dark';
    }

    return `<span class="badge ${bgClass} px-3 py-2">${value}</span>`;
  }
}
